import getToken from './oauth';
import assistantConfigMock from '../resources/mocks/assistantConfigMock.json'
import defaultAssistantConfig from '../resources/json/defaultAssistantConfig.json'
import { AssistantConfig } from '../models/AssistantModel'

export const ROLE_ASSISTANT = "assistant";
export const SOURCE = "web";
const mock = process.env.REACT_APP_ENABLE_MOCK;
const condamindBaseURL = process.env.REACT_APP_CONDAMIND_BASE_URL;
const assistantNowAllowedResponse = {
  response: {
    role: ROLE_ASSISTANT,
    content: "Al parecer no tienes permisos para acceder al assistant solicitado"
  }
}

export let threadID = null

function getMock() {
  return {
    "response": {
      "role": ROLE_ASSISTANT,
      "content": "Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries for previewing layouts and visual mockups. Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries for previewing layouts and visual mockups.\n\n Here is a \"Hello Word\" in Python:\n\n```python\nprint(\"Hola Mundo\")\n```\n\n",
      "thread_id": "thread_mhG1rPneJRWNgsPkMoQuzA56",
      "suggestions": [{
        "title": "¿Podrías darme más detalles sobre su experiencia en Pomelo?"
      }, {
        "title": "¿Qué patrones de diseño domina Matías?"
      }, {
        "title": "¿Cómo ha contribuido Matías al éxito de los proyectos en los que ha participado?]"
      }]
    }
  };
}

async function startThread(token, assistantID, inputMessage) {
  const requestOptions = getRequestOptions(token, assistantID, inputMessage)
  const url = condamindBaseURL + '/chat/thread'

  const response = await fetch(url, requestOptions);
  if (response.status === 403) {
    return assistantNowAllowedResponse
  }
  return await response.json();

}

async function continueThread(token, assistantID, inputMessage) {
  const requestOptions = getRequestOptions(token, assistantID, inputMessage)
  const url = condamindBaseURL + '/chat/thread/' + threadID

  const response = await fetch(url, requestOptions);
  if (response.status === 403) {
    return assistantNowAllowedResponse
  }
  return await response.json();
}

export async function processChatRequest(assistantID, inputMessage) {
  if (mock) {
    const mock = getMock();
    threadID = mock.response.thread_id;
    return mock
  }
  let data
  const token = await getToken();
  if (threadID) {
    data = await continueThread(token, assistantID, inputMessage)
    return data;
  }
  data = await startThread(token, assistantID, inputMessage)
  threadID = data.response.thread_id

  return data
}

export async function getAssistantConfig(assistantID, navigate) {
  if (mock) {
    const assistantConfig = AssistantConfig.fromJSON(assistantConfigMock);
    return assistantConfig
  }
  const token = await getToken();
  const url = condamindBaseURL + '/v1/assistants/' + assistantID
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token,
      'assistant-id': assistantID
    }
  }

  const response = await fetch(url, requestOptions);
  if (response.status > 299) {
    navigate('/');
    return AssistantConfig.fromJSON(defaultAssistantConfig);
  }

  // código inaccesible, lo dejo por si a futuro agregamos autenticación
  if (response.status === 403) {
    return assistantNowAllowedResponse
  }
  if (response.status === 404) {
    return AssistantConfig.fromJSON(defaultAssistantConfig);
  }

  const json_response = await response.json();
  return AssistantConfig.fromJSON(json_response)
}

function getRequestOptions(token, assistantID, inputMessage) {
  // const googleToken = JSON.parse(localStorage.getItem('google_token'))
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token,
      'source': SOURCE,
      // TODO: descomentar cuando tengamos el flujo de calendar
      // 'Google-Token': googleToken,
      'assistant-id': assistantID
    },
    body: JSON.stringify({ "user_message": inputMessage })
  }
}

export async function googleAuth() {
  const url = condamindBaseURL + '/auth/google'
  window.open(url, 'Google OAuth', 'height=600,width=450');
  return true
}